import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  public isMenuVisible: WritableSignal<boolean> = signal(true);

}
